module.exports = __webpack_public_path__ + "img/0-training-technologies@2x.3dc32009.png";